import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Address } from '../warehouse-models';
import { WeatherInfo } from '../components/weather/weather-info.models';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class WeatherService {
  private geocodeUrl = 'https://nominatim.openstreetmap.org/search';
  private weatherUrl = 'https://api.openweathermap.org/data/2.5/weather';

  private weatherApiKey = '46d02e629c05b281374e775544a41073';

  constructor(private http: HttpClient, private translate:TranslateService, private logger: LoggerService) {}

  getCoordinates(address: Address) {
    const query = `${address.streetAddress}, ${address.postalArea}, ${'Finland'}`;
    return this.http.get(`${this.geocodeUrl}?q=${encodeURIComponent(query)}&format=json`);
  }

/**
 *
 * @param lat
 * @param lon
 * @returns Observable with the weather data
 */

  getWeather(lat: number, lon: number) {
    return this.http.get(`${this.weatherUrl}?lat=${lat}&lon=${lon}&appid=${this.weatherApiKey}&units=metric`);
  }

  /**
   * Fetches weather data for a given address.
   * @param street Street name and number
   * @param city City name
   * @param country Country name
   * @returns Observable with weather data
   */

  getWeatherByAddress(address: Address): Observable<WeatherInfo> {
    const query = `${address.streetAddress}, ${address.postalArea}, ${'Finland'}`;
    return this.http
      .get(`${this.geocodeUrl}?q=${encodeURIComponent(query)}&format=json`)
      .pipe(
        switchMap((data: any) => {
          if (!data || !data.length) {
            throwError(() => new Error('No coordinates found for the given address.'));
          }


          const { lat, lon } = data[0];

          return this.http.get<WeatherInfo>(
            `${this.weatherUrl}?lat=${lat}&lon=${lon}&appid=${this.weatherApiKey}&units=metric`
          ).pipe(map((weatherData: WeatherInfo) => {

            weatherData.main.temp = Math.round(weatherData.main.temp);
            weatherData.main.feels_like = Math.round(weatherData.main.feels_like);
            return weatherData;
        }));
      }),
      catchError((error) => {
        this.logger.errorWithContext('WeatherService', 'Error fetching weather data', error);

        // Safely handle cases where error.message is undefined
        const errorMessage =
          error instanceof Error
            ? error.message
            : typeof error === 'string'
            ? error
            : 'An unknown error occurred while fetching weather data.';

        return throwError(() => new Error(errorMessage));
      })
      );
  }
}
